<ng-container *ngIf="images$ | async as images">
	<div class="image-container">
		<app-mobility-image-upload
			[imagePrefix]="imagePrefix"
			*ngFor="let num of images; index as i"
			[index]="i"
			(finished)="handleNewImageUploaded($event, i)"
			[uploadImageToServerCallback]="uploadImageToServerCallback"
		></app-mobility-image-upload>
	</div>
</ng-container>
